import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/'

import Landing from '../views/Landing.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: Landing
  },
  {
    path: '/despre-iss',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/contul-meu',
    name: 'Account',
    component: () => import(/* webpackChunkName: "user" */ '../views/Account.vue'),
    meta: { auth: 'aplicant' }
  },
  {
    path: '/contul-evaluatorului',
    name: 'AccountEvaluator',
    component: () => import(/* webpackChunkName: "evaluator" */ '../views/AccountEvaluator.vue'),
    meta: { auth: 'evaluator' }
  },
  {
    path: '/dashboard',
    name: 'AccountAdmin',
    component: () => import(/* webpackChunkName: "admin" */ '../views/AccountAdmin.vue'),
    meta: { auth: 'admin' }
  },
  {
    path: '/autentificare/:approved?',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/creare-cont',
    name: 'Signup',
    component: () => import(/* webpackChunkName: "signup" */ '../views/Signup.vue')
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "signup" */ '../views/NotFound.vue')
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach(async (to, from, next) => {
  const auth = to.meta.auth || false
  const token = await store.state.feathers.authentication.getAccessToken()

  if (token) {
    await store.dispatch('login')
  }
  const isAllowed = store.getters.user ? store.getters.user.role === auth : false
  const isAapproved = store.getters.user ? store.getters.user.approved : false

  if (auth) { // route requires auth
    if (isAllowed) { // user is logged in and has access to route
      if (isAapproved) { // user is logged in, has access and is approved
        next()
      } else {
        // store.dispatch('logout')
        next({ name: 'Login', params: { approved: false } })
      }
    } else {
      // store.dispatch('logout')
      next({ name: 'Login' })
    }
  } else {
    next()
  }
})

export default router
